// @ai-generated 2026-08-27T08:12:58+00:00 by malte.ulfers@tngtech.com using Claude Opus 5 (1M context)
import type { CommandMessage } from '@utils/toolCallEnvelope';
import classes from './ToolCallFailureReasons.module.css';

/**
 * Why a tool call failed, one line per reason.
 *
 * This is the exception to the transcript's "no payload" rule: a batch command reports one message
 * per rejected record, and without them the card can only say that something failed — which leaves
 * the user unable to act. The reasons are prose the server already wrote for a person to read, not
 * the raw result, which stays in the tool call sidebar.
 */
export function ToolCallFailureReasons({ reasons }: { reasons: CommandMessage[] }) {
    return (
        <ul className={classes.reasons}>
            {reasons.map((reason, index) => (
                <li key={`${reason.title}:${reason.message}:${index}`} className={classes.reason}>
                    {reason.title !== '' && <span className={classes.title}>{reason.title}: </span>}
                    {reason.message}
                </li>
            ))}
        </ul>
    );
}
